import { from } from "rxjs";
import { selectBuildingPurchaseWorkerRequirement } from "../../../../selectors/selectExistingBuildingInfo";
import { IdCharacterHelpType } from "../../../character-help-dialog/IdCharacterHelpType";
import { actionModalOpen } from "../../../modals/actionModal";
import { IdModal } from "../../../modals/IdModal";
import { actionOngoingPurchaseCharacterHelpSelect } from "../../../ongoing-purchase/actionOngoingPurchase";
export var pathBuildingPurchaseCharacterHelpMissingWorker = function (action, state$) {
    var state = state$.value;
    var _a = selectBuildingPurchaseWorkerRequirement(state, action.building, 0), freeWorkers = _a.freeWorkers, workerRequirement = _a.workerRequirement;
    var missingWorker = workerRequirement - freeWorkers;
    return from([
        actionOngoingPurchaseCharacterHelpSelect({
            missing: missingWorker.toString(),
            type: IdCharacterHelpType.MissingWorkers,
        }),
        actionModalOpen(IdModal.CharacterHelp),
    ]);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/path/pathBuildingPurchaseCharacterHelpMissingWorker.ts
// module id = 2066
// module chunks = 3